import { toast } from "react-toastify"
import { addEditDataAPI } from "services/CRUDServices"
import { getPrice } from "tools/functions/Methods"

export const calculateSettlement = (data) => {
  const totalCredit = data.reduce(
    (sum, item) => sum + (item.creditorsLedger || 0),
    0
  )
  const totalDebtor = data.reduce(
    (sum, item) => sum + (item.debtorsLedger || 0),
    0
  )
  const result = totalCredit - totalDebtor
  return result
}

export const sync = (item, refreshTable) => {
  addEditDataAPI(
    `/core-api/hub_credit/syncCreateCreditByAllocation/${item.id}`,
    "post",
    {}
  ).then((res) => {
    refreshTable()
  })
}

// export const calculateUsedCredit = (data, seprate = false) => {
//   const totalCredit =
//     data?.settlements.reduce(
//       (sum, item) => sum + (item.creditorsLedger || 0),
//       0
//     ) || 0
//   const result = data.creditAmount - data.usedCredit + totalCredit
//   return seprate ? getPrice(result) : result
// }

export const credtiDetail = (item) => {
  addEditDataAPI(
    `/customer-api/subsidiaryLedger/findByCredit/${item.id}`,
    "post",
    {}
  )
}

export function checkSameHub(selectedRow) {
  const allCreditorHubIdsSame = selectedRow.every(
    (item, arr) => item?.creditorHubId === arr[0]?.creditorHubId
  )
  if (allCreditorHubIdsSame) {
    toast.error("همه موارد پرداخت باید متعلق به یک هاب باشند")
    throw new Error("")
  }
}
export function createPaymentPrice(selectedRow) {
  const referenceList = selectedRow
    .filter((item) => item.settlementStatus !== 1)
    .map((item) => ({
      cod: null,
      postPaid: null,
      reference: {
        id: item?.id,
        text: item.creditorHubId,
      },
    }))
  return {
    hub: { id: selectedRow[0]?.creditorHubId },
    amount: selectedRow.reduce(
      (a, b) => a + +b.totalPayable.split(",").join(""),
      0
    ),
    referenceList,
  }
}
